import Nav from './Nav';
import Footer from './Footer';
import SideList from './SideList';
import ChapterDetail1 from './ChapterDetail1';
import ChapterDetail2 from './ChapterDetail2';
import ChapterDetail3 from './ChapterDetail3';
import ChapterDetail4 from './ChapterDetail4';
import ChapterDetail5 from './ChapterDetail5';
import ChapterDetail6 from './ChapterDetail6';
import ChapterDetail7 from './ChapterDetail7';
import ChapterDetail8 from './ChapterDetail8';
import ChapterDetail9 from './ChapterDetail9';
import ChapterDetail10 from './ChapterDetail10';
import ChapterDetail11 from './ChapterDetail11';
import ChapterDetail12 from './ChapterDetail12';
import { useLocation } from 'react-router-dom';

export default function Chapter(props) {
  let selectedChapter;
  const location = useLocation().pathname;

  if (location === "/chapter1") {
    selectedChapter = <ChapterDetail1 text={props.text}/>
  } else if (location === "/chapter2") {
    selectedChapter = <ChapterDetail2 text={props.text}/>
  } else if (location === "/chapter3") {
    selectedChapter = <ChapterDetail3 text={props.text}/>
  } else if (location === "/chapter4") {
    selectedChapter = <ChapterDetail4 text={props.text}/>
  } else if (location === "/chapter5") {
    selectedChapter = <ChapterDetail5 text={props.text}/>
  } else if (location === "/chapter6") {
    selectedChapter = <ChapterDetail6 text={props.text}/>
  } else if (location === "/chapter7") {
    selectedChapter = <ChapterDetail7 text={props.text}/>
  } else if (location === "/chapter8") {
    selectedChapter = <ChapterDetail8 text={props.text}/>
  } else if (location === "/chapter9") {
    selectedChapter = <ChapterDetail9 text={props.text}/>
  } else if (location === "/chapter10") {
    selectedChapter = <ChapterDetail10 text={props.text}/>
  } else if (location === "/chapter11") {
    selectedChapter = <ChapterDetail11 text={props.text}/>
  } else if (location === "/chapter12") {
    selectedChapter = <ChapterDetail12 text={props.text}/>
  }
  
  return (
    <>
      <Nav />
      <div className="mx-auto flex">
        <aside className="hidden md:flex ml-4 my-4 whitespace-nowrap md:basis-2/12 sticky top-16 h-screen md:flex-col overflow-y-auto">
          <SideList link="/chapter1" text="Chapter I" />
          <SideList link="/chapter2" text="Chapter II" />
          <SideList link="/chapter3" text="Chapter III" />
          <SideList link="/chapter4" text="Chapter IV" />
          <SideList link="/chapter5" text="Chapter V" />
          <SideList link="/chapter6" text="Chapter VI" />
          <SideList link="/chapter7" text="Chapter VII" />
          <SideList link="/chapter8" text="Chapter VIII" />
          <SideList link="/chapter9" text="Chapter IX" />
          <SideList link="/chapter10" text="Chapter X" />
          <SideList link="/chapter11" text="Chapter XI" />
          <SideList link="/chapter12" text="Chapter XII" />
        </aside>
        <main className="mx-4 lg:mx-8 my-4 md:basis-10/12 text-lg font-source text-justify">
          <h3 className="mb-2 font-semibold font-inter text-left text-xl lg:text-2xl">{props.text}</h3>
          {selectedChapter}
        </main>
      </div>
      <Footer />
    </>
  )
}